const getQueue = async ({ params, api }) => {
  return await api(`queue/${params.id}`)
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default getQueue;
